import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';

export const archiveLocationMutation = gql`
  mutation archiveLocation($id: Int!) {
    archiveLocation(id: $id) {
      id
    }
  }
`;

export class LocationArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    /**
     * Random note - `location` also comes through via react router. Because this container is connected to react router, our
     * `location` object that is passed through as a prop would get overwritten by the react router prop of the same name.
     * Instead use the prop name `loc`
     */
    const { className, loc, history, client } = this.props;
    const { submitting, error, isOpen } = this.state;

    if (!loc) {
      // In some cases where location comes though asyncronously, there is a chance that the location
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    const { id, name } = loc;

    return (
      <Mutation mutation={archiveLocationMutation}>
        {archiveLocation => (
          <Fragment>
            <Button className={className} color="danger" outline onClick={this.onToggle}>
              Archive
            </Button>
            <Modal isOpen={isOpen} toggle={this.onToggle}>
              <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
              <ModalBody>
                {error && <Alert color="danger">{error}</Alert>}
                Are you sure you want to archive the location <em>{name}</em>?
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.onToggle}>
                  Cancel
                </Button>{' '}
                <Button
                  disabled={submitting}
                  color="danger"
                  onClick={async () => {
                    try {
                      this.setSubmitting(true);
                      await archiveLocation({
                        variables: {
                          id
                        }
                      });
                      // Clear cache
                      client.resetStore();
                      history.push(`/settings/locations?archived=${name}`);
                    } catch (err) {
                      this.setSubmitting(false);
                      this.setError('An unknown error occured');
                    }
                  }}
                >
                  Archive
                </Button>
              </ModalFooter>
            </Modal>
          </Fragment>
        )}
      </Mutation>
    );
  }
}

export default withRouter(withApollo(LocationArchive));



// WEBPACK FOOTER //
// ./src/containers/locationArchive/locationArchive.jsx